import React, { Component } from 'react';
import './customerService.less';
import clientApi from '../../api/client';
import AXIOS from '../../api/axios';

export default class CustomerService extends Component {
    constructor(props){
        super(props);
        this.state = {
            csUrl: "https://www.sobot.com/chat/h5/index.html?sysNum=68243cdfdbc54199a4626e6e77f3b8b3&source=2",
            csUrlPc: ''
        }
    }

    componentWillMount(){
        AXIOS.getCsQrCode({data: {}}, (res, err) => {
            if(err) alert(err.errorMessage)
            else{
                this.setState({ csUrlPc: res.csQrCodeUrl });
            }
        })
    }

    toCS = () => {
        const { questionId } = this.props;
        const { csUrl } = this.state;
        let eventData = {
            eventType: 'c2_app_My_Help_Consult'
        };
        if(questionId){
            eventData.eventType = 'c2_app_My_Help_Question_Consult';
            eventData.questionId = questionId;
        }
        clientApi.eventTracking(eventData);
        window.location.href = csUrl;
    }

    render(){
        const { isMobile } = this.props;
        const { csUrlPc } = this.state;
        if(!isMobile){
            return (
                <div className="customerService pc">
                    <div className="erweima">
                        <img src={ csUrlPc } alt="" />
                    </div>
                    <div className="text">打开微信扫一扫关注公众号通过“在线服务” > "咨询小助手"</div>
                </div>
            )
        }
        return(
            <div 
                className="customerService mobile"
                onClick={ this.toCS }
            >
                <div className="icon"></div>
                <div className="text">咨询小助手</div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/feedbackPage/customerService.jsx